import * as THREE from "three";


/* 点のフォーマット変換
*  Variables
* vpoint: THREE.Vector3
* point:  [x, y, z]
* voints: [THREE.Vector3]
* points: [[x1, y1, z1], [x2, y2, z2], ... ]
* parray: [[x1, y1, z1, x2, y2, z2, ... ]
*/
export function Vpoints2Points(vpoints){
  var points = [];
  vpoints.forEach((v) => {
    points.push([v.x, v.y, v.z]);
  });
  return points;
}

/*export function Points2Vpoints(points){
  var vpoints = [];
  points.forEach( pt => {
    vpoints.push(new THREE.Vector3(pt[0], pt[1], pt[2]));
  });
  return vpoints;
}*/

/*export function Points2Vpoints2D(points2D){
  var vpoints = [];
  points2D.forEach( pt => {
    vpoints.push(new THREE.Vector3(0, pt[0], pt[1]));
  });
  return vpoints;
}*/

export function Vpoints2Array(vpoints){
  var parray = [];
  vpoints.forEach((v) => {
    parray.push(v.x);
    parray.push(v.y);
    parray.push(v.z);
  });
  return parray;
}

export function Array2Vpoints(parray){
  var vpoints = [];
  for (var j = 0; j < parray.length / 3; j++) {
    vpoints.push(new THREE.Vector3(
      parray[j * 3], 
      parray[j * 3 + 1], 
      parray[j * 3 + 2]
    ));
  }
  return vpoints;
}

// v3d: THREE.Vector3
// v2d: THREE.Vector2
export function toXZ(v3d){
  return new THREE.Vector2(v3d.x, v3d.z);
}
export function toXY(v3d){
  return new THREE.Vector2(v3d.x, v3d.y);
}
export function toYZ(v3d){
  return new THREE.Vector2(v3d.y, v3d.z);
}
